import React, {useState} from 'react';
import {Outlet} from 'react-router-dom';
import AdminNav from './AdminNav';
import {AdminProvider, useAdmin} from './AdminContext';

const AdminLoginScreen: React.FC = () => {
  const {login} = useAdmin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState<string | null>(null);
  const [loginLoading, setLoginLoading] = useState(false);

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoginLoading(true);
    setLoginError(null);
    try {
      await login(username, password);
      setPassword('');
    } catch (error) {
      setLoginError(error instanceof Error ? error.message : 'Prijava nije uspela.');
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] bg-neutral-50 py-16 px-4">
      <div className="mx-auto max-w-md rounded-2xl border border-neutral-200 bg-white p-8 shadow-soft">
        <div className="mb-6">
          <p className="text-sm uppercase tracking-[0.3em] text-neutral-400">Admin</p>
          <h1 className="text-3xl font-semibold text-neutral-900">Prijava</h1>
          <p className="mt-2 text-neutral-500">Pristup je dozvoljen samo administratorima.</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            className="input-field"
            type="text"
            placeholder="Korisnicko ime"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
            required
          />
          <input
            className="input-field"
            type="password"
            placeholder="Lozinka"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />
          {loginError && <p className="text-sm text-red-600">{loginError}</p>}
          <button className="btn-primary w-full" type="submit" disabled={loginLoading}>
            {loginLoading ? 'Prijavljivanje...' : 'Prijavi se'}
          </button>
        </form>
      </div>
    </div>
  );
};

const AdminShell: React.FC = () => {
  const {token, logout} = useAdmin();
  if (!token) return <AdminLoginScreen />;

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="w-full py-10">
        <div className="mb-6 flex flex-wrap items-center justify-between gap-4 px-6">
          <div>
            <p className="text-sm uppercase tracking-[0.3em] text-neutral-400">Admin panel</p>
          </div>
          <button className="btn-outline" type="button" onClick={logout}>
            Odjava
          </button>
        </div>
        <div className="grid gap-8 lg:grid-cols-[300px_1fr]">
          <AdminNav />
          <div className="space-y-6 pr-6">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

const AdminLayout: React.FC = () => (
  <AdminProvider>
    <AdminShell />
  </AdminProvider>
);

export default AdminLayout;
